/**
 * @module experience/shop/cart
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */

export const DEVICE_TYPE = {
  SCANNER: 'scanner',
  KEYBOARD: 'keyboard',
  SIM_CARD: 'simcard',
};
